import React from "react";
import { FaBell } from "react-icons/fa";
 // Make sure this CSS file is imported

function NotificationBar() {
  const notifications = [
    "Welcome to Chitracrop Science!",
    "Innovating for Sustainable Agriculture!",
    "Advanced Crop Protection Solutions!",
    "Healthy Soil, Healthy Future!",
    "Empowering Farmers with Technology!",
  ];

  return (
    <div className="notification-wrapper" >
      <div className="notification-title d-flex align-items-center">
        <FaBell className="me-2" />
      </div>
      <div className="notification-marquee">
        <div className="notification-track">
          {notifications.concat(notifications).map((note, index) => (
            <span key={index} className="notification-item">
              {note}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default NotificationBar;
